export default "__VITE_ASSET__8Oaa7r9J__"